import { ExtendableError } from './extendableError.mjs';

export class NotFoundError extends ExtendableError {}
